// @flow
import React from "react";
import type { IconProps } from "./";

export default function Warning({
  fill = "#D75A4A",
  width = "50px"
}: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width={width}>
      <circle cx="25" cy="25" r="25" fill={fill} />
      <polyline
        points="16,34 25,25 34,16 
	"
        stroke="#fff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-miterlimit="10"
      />
      <polyline
        points="16,16 25,25 34,34 
	"
        stroke="#fff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-miterlimit="10"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Error.js